module.exports = __webpack_public_path__ + "img/Master-2.ec823a21.gif";